<template>
  <input type="text" class="vendor-input" v-model="model"
    oninput="let p=this.selectionStart;this.value=this.value.toUpperCase();this.setSelectionRange(p, p);"
    :disabled="disabled" />
</template>
<script>
export default {
  props: ['storeName', 'modelName', 'mutationName', 'disabled'],
  created() {
  },
  computed: {
    model: {
      get() {
        return this.$store.state[this.storeName][this.modelName]
      },
      set(newValue) {
        this.$store.commit(this.mutationName, {
          name: this.modelName,
          value: newValue,
        })
      },
    },
  },
}
</script>
